import { FC, PropsWithChildren } from 'react'

import { cn } from '@/app/utils'

type Props = PropsWithChildren<{
  className?: string
}>

const PagePlugContainer: FC<Props> = ({ children, className }) => {
  return (
    <div
      className={cn(
        'flex h-[calc(100vh-160px)] items-center justify-center',
        className
      )}
    >
      {children}
    </div>
  )
}

export { PagePlugContainer }
